import CircleContactInfo from '../src/CircleContactInfo';
export default CircleContactInfo;
